<!DOCTYPE html>
<html lang="en">
<meta http-equiv="content-type" content="text/html;charset=utf-8" />

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Food Safety On Wheels</title>
    <script src="/assets/js/jquery.min.js"></script>

    <link rel="stylesheet" href="/assets/css/bootstrap.css" />
    <!-- <link rel="stylesheet" href="/fsw/assets/css/bootstrap.min.css" /> -->
    <link rel="stylesheet" href="/assets/css/style.css" />
    <link rel="stylesheet" href="/assets/css/responsive.css" />
    <!-- <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,500;0,600;0,700;0,800;1,800&display=swap" rel="stylesheet">
   -->

</head>

<body>
    <section class="top-menu">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <nav class="navbar navbar-expand-md bg-dark navbar-dark">
                        <a class="navbar-brand" href="#"><img src="/assets/img/logo.png" class="img-fluid"></a>
                        <button class="navbar-toggler" type="button" data-toggle="collapse"
                            data-target="#collapsibleNavbar">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse justify-content-end" id="collapsibleNavbar">
                            <ul class="navbar-nav">
                                <li class="nav-item">
                                    <a class="nav-link" [routerLink]="['/home']">Home</a>
                                </li>
                                <!-- <li class="nav-item">
                                    <a class="nav-link" href="/about-us.html">About Us</a>
                                </li> -->
                                <li class="nav-item">
                                    <a class="nav-link" [routerLink]="['/contact']">Contact</a>
                                </li>
                                <!-- <li class="nav-item">
                  <button type="button" class="btn btn-primary" data-toggle="modal"
                    attr.data-target="#myModal">Login</button>
                </li> -->
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </section>

    <div class="container" *ngIf="isOtpMode" style="margin-top: 100px;margin-left:500px;">
        <div class="row">
            <div class="col-mod-12">
                <div class="card card-outline card-primary" style="width: 400px;"> 
                    <h5 class="card-header text-center">OTP Verification</h5>
                    <div class="card-body">
                        <div><b>User Id:</b> {{userId}}</div>
                        <label>Enter Email OTP </label> <input [(ngModel)]="emailotp" class="form-control">
                        <br />
                        <label>Enter Mobile OTP </label> <input [(ngModel)]="smsotp" class="form-control">
                        <br />
                        <div class="row">
                            <div class="col"><input type="button" class="btn btn-primary" value="Submit"
                                    (click)="checkOtp()" /> </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>



    <div class="container" *ngIf="!isOtpMode" style="margin-top: 100px;margin-left:400px;">
        <div class="row">
            <div class="col-mod-12">
                <br>
                <div class="card" style="width: 400px;">
                    <h5 class="card-header">Set New Password</h5>
                    <div class="card-body">
                        <label>Enter Password </label> <input type="password" [(ngModel)]="pwd" class="form-control"
                            minlength="6">
                        <label>Confirm Password </label> <input type="password" [(ngModel)]="cnfrmpwd"
                            class="form-control" minlength="6">
                        <br />
                        <div class="row">
                            <div class="col"><input type="button" class="btn btn-primary" value="Update"
                                    (click)="chngPswrd()" /> </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>